import Vue from 'vue';

export const mainClassConfig = Vue.observable({
    isFullScreen: false,
});

export const setFullScreen = (isFullScreen: boolean) => {
    mainClassConfig.isFullScreen = isFullScreen;

    if (isFullScreen) {
        document.documentElement.classList.add('full-screen');
    } else {
        document.documentElement.classList.remove('full-screen');
    }
};
